export default "__VITE_ASSET__e20280a3__"